import { Routes } from '@angular/router';
import { LocalLoadsComponent } from './local-loads.component';
import { ImportLocalLoadsComponent } from './import-local-loads/import-local-loads.component';
import { FindLoadsComponent } from './find-loads/find-loads.component';
import { ManageLocalLoadsGuard } from '../core/guards/manage-local-loads.guard';
import { ReorderLoadsComponent } from './reorder-loads/reorder-loads.component';
import { PendingChangesActionGuard } from '../core/guards/pending-changes-action.guard';
import { LocationsComponent } from './locations/locations.component';
import { ManageLocationsGuard } from '../core/guards/manage-locations.guard';
import { ManagePlantsGuard } from '../core/guards/manage-plants.guard';
import { PlantManagerLocationsComponent } from './locations/plant-manager-locations.component';
import { CreateLocalLoadComponent } from './create-local-load/create-local-load.component';
import { ManageAllLocalLoadsGuard } from '../core/guards/manage-all-local-loads.guard';
import {AuthGuard} from '@auth0/auth0-angular';

export const LOCAL_LOADS_ROUTES: Routes = [
  {
    path: 'local-loads',
    data: { localLoadsView: true },
    component: LocalLoadsComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'import', component: ImportLocalLoadsComponent, canActivate: [ManageLocalLoadsGuard] },
      { path: 'find', component: FindLoadsComponent, canActivate: [ManageLocalLoadsGuard], canDeactivate: [PendingChangesActionGuard] },
      { path: 'reorder', component: ReorderLoadsComponent, canActivate: [ManageLocalLoadsGuard] },
      { path: 'locations', component: LocationsComponent, canActivate: [ManageLocationsGuard] },
      { path: 'manual/creation', component: CreateLocalLoadComponent, canActivate: [ManageAllLocalLoadsGuard] },
      { path: '**', redirectTo: 'import' }
    ]
  },
  { path: 'manage-plants', component: PlantManagerLocationsComponent, canActivate: [ManagePlantsGuard] },
];
